export default __webpack_public_path__ + "static/media/search-doc-icon.2f187936.svg";